import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import {Button} from "reactstrap";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";

const LABELS = {
	low_dollar_average: "Low Dollar Average (whole dollars, e.g. 140)",
	av_conversion: "AV Conversion (whole percent, e.g. 25)",
	low_reviews: "Reviews (whole percent, e.g. 25)",
	high_four_point_waived: "Four-Point Waived (whole percent, e.g. 25)",
	low_cards: "Cards Left (whole percent, e.g. 25)",
};

export default class FeMetricThresholds extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			values: {},
			saving: null,
		};
	}

	async componentDidMount() {
		const model = new API.BuildClass(Types.Fe_Metrics._name, "GET_THRESHOLDS");
		const data = await model.submit(null, "GET_THRESHOLDS");
		const items = data?.items || {};
		const values = {};
		Object.keys(LABELS).forEach((key) => {
			values[key] = items[key]?.amount ?? "";
		});
		this.setState({values});
	}

	save = async (category) => {
		this.setState({saving: category});
		try {
			const raw = String(this.state.values[category] ?? "").trim();
			if (raw !== "" && !/^\d+$/.test(raw)) {
				window.alert("Enter a whole number, or leave blank to disable alerts.");
				return;
			}
			const model = new API.BuildClass(Types.Fe_Metrics._name, "POST_THRESHOLDS");
			model.object = {
				category,
				amount_input: raw,
			};
			await model.submit(null, "POST_THRESHOLDS");
			await this.componentDidMount();
		} catch (error) {
			window.alert("Could not save that threshold. Try again.");
		} finally {
			this.setState({saving: null});
		}
	};

	render() {
		return (
			<Card>
				<CardContent>
					<p>Blank means do not alert. Amounts are whole numbers: $140 or 25%.</p>
					{Object.keys(LABELS).map((category) => (
						<div key={category} className="d-flex align-items-end mb-3">
							<TextField
								label={LABELS[category]}
								value={this.state.values[category] ?? ""}
								onChange={(event) => this.setState({values: {...this.state.values, [category]: event.target.value}})}
								style={{minWidth: 420, marginRight: 12}}
							/>
							<Button color="primary" disabled={this.state.saving === category} onClick={() => this.save(category)}>Save</Button>
						</div>
					))}
				</CardContent>
			</Card>
		);
	}
}
